(function () {
  'use strict';

  /*
   * ============================================================
   * COLOR WOW FREE GIFT
   * ============================================================
   *
   * Buy 2+ COLOR WOW products
   * → Automatically add 1 free gift at €0.00
   *
   * Features:
   * - Normal Add to Cart support
   * - Quick Add support
   * - Quantity +/- support
   * - Manual quantity changes
   * - Automatic gift addition
   * - Automatic gift removal
   * - Prevents gift counting as a qualifying product
   * - Reopens side cart after page refresh
   * - Protects checkout if customer no longer qualifies
   * - Prevents duplicate gift additions
   *
   * ============================================================
   */


  /*
   * ============================================================
   * SETTINGS
   * ============================================================
   */

  /*
   * IMPORTANT:
   * Replace this with the actual VARIANT ID of your
   * COLOR WOW free gift.
   */

  const FREE_GIFT_VARIANT_ID = 57416258388343;

  const COLOR_WOW_VENDOR = 'COLOR WOW';

  const MIN_COLOR_WOW_PRODUCTS = 2;

  /*
   * Private line item property used to identify
   * the promotional gift.
   */

  const GIFT_PROPERTY = '_color_wow_gift';


  /*
   * ============================================================
   * SELECTORS
   * ============================================================
   */

  /*
   * Your Quick Add button:
   *
   * <button
   *   class="btn btn--full product-card__variant is-selected"
   *   data-variant-id="..."
   * >
   */

  const QUICK_ADD_SELECTOR =
    '.product-card__variant[data-variant-id]';


  /*
   * Your side cart checkout button:
   *
   * #react-side-cart
   * .side-cart__checkout
   * a[href="/checkout"]
   */

  const SIDE_CART_CHECKOUT_SELECTOR =
    '#react-side-cart .side-cart__checkout a[href="/checkout"]';


  /*
   * Your side cart open button:
   *
   * <a ... data-toggle-cart="">
   */

  const SIDE_CART_TRIGGER_SELECTOR =
    '[data-toggle-cart]';


  /*
   * ============================================================
   * STATE
   * ============================================================
   */

  let giftUpdateInProgress = false;

  let checkoutInProgress = false;


  /*
   * Used to remember that the side cart was open
   * before a page refresh.
   */

  const SIDE_CART_REOPEN_KEY =
    'color_wow_reopen_side_cart';


  /*
   * ============================================================
   * GET CURRENT CART
   * ============================================================
   */

  async function getCart() {

    try {

      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          method: 'GET',

          headers: {
            'Accept': 'application/json'
          },

          /*
           * Make sure we get the latest cart
           * rather than a cached response.
           */

          cache: 'no-store'
        }
      );


      if (!response.ok) {

        throw new Error(
          'Could not load cart'
        );

      }


      return await response.json();


    } catch (error) {

      console.error(
        'COLOR WOW gift: cart error',
        error
      );

      return null;

    }

  }


  /*
   * ============================================================
   * COUNT COLOR WOW PRODUCTS
   * ============================================================
   *
   * Counts the quantity of COLOR WOW products.
   *
   * The free gift itself is ignored.
   */

  function getColorWowQuantity(cart) {

    let quantity = 0;


    cart.items.forEach(function (item) {

      /*
       * Never count the free gift.
       */

      if (
        Number(item.variant_id) ===
        Number(FREE_GIFT_VARIANT_ID)
      ) {

        return;

      }


      /*
       * Shopify cart.js normally provides vendor.
       */

      const vendor =
        (item.vendor || '')
          .trim()
          .toUpperCase();


      if (
        vendor === COLOR_WOW_VENDOR
      ) {

        quantity += item.quantity;

      }

    });


    return quantity;

  }


  /*
   * ============================================================
   * FIND PROMOTIONAL FREE GIFT
   * ============================================================
   *
   * We check BOTH:
   *
   * 1. Variant ID
   * 2. Private gift property
   *
   * This means a customer adding the same product
   * normally won't accidentally have it treated
   * as our promotional gift.
   */

  function getGiftItem(cart) {

    return cart.items.find(function (item) {

      return (

        Number(item.variant_id) ===
        Number(FREE_GIFT_VARIANT_ID)

        &&

        item.properties

        &&

        item.properties[GIFT_PROPERTY] === 'true'

      );

    });

  }


  /*
   * ============================================================
   * REMEMBER SIDE CART STATE
   * ============================================================
   *
   * Called immediately before we refresh the page.
   *
   * If the side cart is open, we store that information
   * in sessionStorage.
   */

  function rememberSideCartState() {

    const sideCart =
      document.querySelector(
        '#react-side-cart'
      );


    if (!sideCart) {

      return;

    }


    /*
     * Check common open states.
     */

    const isOpen =
      sideCart.classList.contains('is-open') ||
      sideCart.classList.contains('active') ||
      sideCart.getAttribute('aria-hidden') === 'false' ||
      sideCart.offsetParent !== null;


    if (isOpen) {

      console.log(
        'COLOR WOW gift: side cart is open - remembering state'
      );


      sessionStorage.setItem(
        SIDE_CART_REOPEN_KEY,
        'true'
      );

    }

  }


  /*
   * ============================================================
   * REOPEN SIDE CART AFTER REFRESH
   * ============================================================
   *
   * Your exact cart trigger is:
   *
   * [data-toggle-cart]
   *
   * We trigger that same element after the page
   * has finished loading.
   */

  function reopenSideCartAfterRefresh() {

    const shouldReopen =
      sessionStorage.getItem(
        SIDE_CART_REOPEN_KEY
      );


    /*
     * Nothing to do if the cart wasn't open
     * before the refresh.
     */

    if (
      shouldReopen !== 'true'
    ) {

      return;

    }


    /*
     * Remove the flag immediately.
     *
     * This prevents the side cart opening again
     * on every subsequent page load.
     */

    sessionStorage.removeItem(
      SIDE_CART_REOPEN_KEY
    );


    /*
     * Give the theme / React side cart time
     * to initialise.
     */

    setTimeout(function () {

      const cartTrigger =
        document.querySelector(
          SIDE_CART_TRIGGER_SELECTOR
        );


      if (!cartTrigger) {

        console.warn(
          'COLOR WOW gift: side-cart trigger not found'
        );

        return;

      }


      console.log(
        'COLOR WOW gift: reopening side cart'
      );


      /*
       * Trigger the exact same cart button
       * the customer normally clicks.
       */

      cartTrigger.click();


    }, 700);

  }


  /*
   * ============================================================
   * ADD FREE GIFT
   * ============================================================
   */

  async function addGift() {

    console.log(
      'COLOR WOW gift: adding free gift'
    );


    try {

      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({

            items: [

              {
                id: FREE_GIFT_VARIANT_ID,

                quantity: 1,

                properties: {
                  [GIFT_PROPERTY]: 'true'
                }
              }

            ]

          })

        }
      );


      if (!response.ok) {

        throw new Error(
          'Could not add free gift'
        );

      }


      console.log(
        'COLOR WOW gift: free gift added'
      );


      /*
       * Remember the side cart before refreshing.
       */

      rememberSideCartState();


      /*
       * Refresh the page.
       */

      window.location.reload();


      return true;


    } catch (error) {

      console.error(
        'COLOR WOW gift: could not add free gift',
        error
      );

      return false;

    }

  }


  /*
   * ============================================================
   * REMOVE FREE GIFT
   * ============================================================
   *
   * refreshPage = true
   *   → Remove gift and refresh page.
   *
   * refreshPage = false
   *   → Remove gift without refreshing.
   *     Used immediately before checkout.
   */

  async function removeGift(
    giftItem,
    refreshPage = true
  ) {

    if (!giftItem) {

      return false;

    }


    console.log(
      'COLOR WOW gift: removing free gift'
    );


    try {

      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({

            id: giftItem.key,

            quantity: 0

          })

        }
      );


      if (!response.ok) {

        throw new Error(
          'Could not remove free gift'
        );

      }


      console.log(
        'COLOR WOW gift: free gift removed'
      );


      /*
       * Normal gift removal.
       *
       * Remember side cart and refresh.
       */

      if (refreshPage) {

        rememberSideCartState();

        window.location.reload();

      }


      return true;


    } catch (error) {

      console.error(
        'COLOR WOW gift: could not remove free gift',
        error
      );

      return false;

    }

  }


  /*
   * ============================================================
   * UPDATE GIFT
   * ============================================================
   */

  async function updateGift() {

    /*
     * Prevent multiple cart events from
     * running this function simultaneously.
     */

    if (giftUpdateInProgress) {

      return;

    }


    giftUpdateInProgress = true;


    try {

      const cart =
        await getCart();


      if (!cart) {

        return;

      }


      const colorWowQuantity =
        getColorWowQuantity(cart);


      const giftItem =
        getGiftItem(cart);


      console.log(
        'COLOR WOW products:',
        colorWowQuantity,
        'Free gift:',
        !!giftItem
      );


      /*
       * ========================================================
       * CUSTOMER QUALIFIES
       * ========================================================
       *
       * 2 or more COLOR WOW products.
       */

      if (
        colorWowQuantity >=
        MIN_COLOR_WOW_PRODUCTS
      ) {

        /*
         * Add the gift if it isn't already there.
         */

        if (!giftItem) {

          await addGift();

        }


        return;

      }


      /*
       * ========================================================
       * CUSTOMER DOES NOT QUALIFY
       * ========================================================
       *
       * Less than 2 COLOR WOW products.
       */

      if (giftItem) {

        await removeGift(
          giftItem
        );

      }

    } finally {

      giftUpdateInProgress = false;

    }

  }


  /*
   * ============================================================
   * QUICK ADD SUPPORT
   * ============================================================
   *
   * Exact Quick Add selector:
   *
   * .product-card__variant[data-variant-id]
   *
   * The theme adds the product asynchronously.
   *
   * Therefore we check several times after the click.
   */

  async function checkGiftAfterQuickAdd() {

    /*
     * Check after 500ms.
     */

    await new Promise(function (resolve) {

      setTimeout(
        resolve,
        500
      );

    });


    await updateGift();


    /*
     * Check again after another 700ms.
     */

    await new Promise(function (resolve) {

      setTimeout(
        resolve,
        700
      );

    });


    await updateGift();


    /*
     * Final check.
     */

    await new Promise(function (resolve) {

      setTimeout(
        resolve,
        800
      );

    });


    await updateGift();

  }


  /*
   * ============================================================
   * QUANTITY SELECTOR SUPPORT
   * ============================================================
   *
   * Your quantity selector is:
   *
   * .quantity-selector
   *
   * with:
   *
   * button
   * input[name="quantity"]
   * button
   *
   *
   * Handles:
   *
   * 1 → 2 COLOR WOW
   *   → add gift
   *
   * 2 → 1 COLOR WOW
   *   → remove gift
   */

  function checkGiftAfterQuantityChange() {

    /*
     * First check.
     */

    setTimeout(
      updateGift,
      500
    );


    /*
     * Second check for slower AJAX requests.
     */

    setTimeout(
      updateGift,
      1200
    );

  }


  /*
   * ============================================================
   * CHECKOUT PROTECTION
   * ============================================================
   *
   * This is the final safety check.
   *
   * Example:
   *
   * Customer has:
   *
   * 2 COLOR WOW
   * + FREE GIFT
   *
   * Customer removes one COLOR WOW.
   *
   * Before the gift-removal AJAX request finishes,
   * customer immediately clicks Checkout.
   *
   * This function checks the cart again before
   * allowing checkout.
   */

  async function protectCheckout(event) {

    /*
     * Stop the theme's normal checkout action.
     */

    event.preventDefault();

    event.stopPropagation();


    /*
     * Stop other click handlers where supported.
     */

    if (
      typeof event.stopImmediatePropagation ===
      'function'
    ) {

      event.stopImmediatePropagation();

    }


    /*
     * Prevent double-clicks.
     */

    if (checkoutInProgress) {

      return;

    }


    checkoutInProgress = true;


    console.log(
      'COLOR WOW gift: checking cart before checkout'
    );


    try {

      const cart =
        await getCart();


      /*
       * If we cannot verify the cart,
       * don't allow checkout to continue.
       */

      if (!cart) {

        console.error(
          'COLOR WOW gift: unable to verify cart before checkout'
        );

        checkoutInProgress = false;

        return;

      }


      const colorWowQuantity =
        getColorWowQuantity(cart);


      const giftItem =
        getGiftItem(cart);


      console.log(
        'COLOR WOW checkout check:',
        'products =',
        colorWowQuantity,
        'gift =',
        !!giftItem
      );


      /*
       * ========================================================
       * CUSTOMER STILL QUALIFIES
       * ========================================================
       */

      if (
        colorWowQuantity >=
        MIN_COLOR_WOW_PRODUCTS
      ) {

        console.log(
          'COLOR WOW checkout: customer qualifies'
        );


        /*
         * Customer qualifies.
         * Go directly to checkout.
         */

        window.location.href =
          `${window.Shopify.routes.root}checkout`;


        return;

      }


      /*
       * ========================================================
       * CUSTOMER NO LONGER QUALIFIES
       * ========================================================
       */

      if (giftItem) {

        console.log(
          'COLOR WOW checkout: removing non-qualified gift'
        );


        /*
         * Remove the gift WITHOUT refreshing.
         */

        const removed =
          await removeGift(
            giftItem,
            false
          );


        if (!removed) {

          console.error(
            'COLOR WOW checkout: could not remove gift'
          );

          checkoutInProgress = false;

          return;

        }

      }


      /*
       * ========================================================
       * GO TO CHECKOUT
       * ========================================================
       */

      console.log(
        'COLOR WOW checkout: proceeding'
      );


      window.location.href =
        `${window.Shopify.routes.root}checkout`;


    } catch (error) {

      console.error(
        'COLOR WOW checkout protection error',
        error
      );


      checkoutInProgress = false;

    }

  }


  /*
   * ============================================================
   * PAGE LOAD
   * ============================================================
   */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      /*
       * Reopen side cart if it was open
       * before the page refresh.
       */

      reopenSideCartAfterRefresh();


      /*
       * Check current cart.
       */

      updateGift();

    }
  );


  /*
   * ============================================================
   * COMMON SHOPIFY / THEME CART EVENTS
   * ============================================================
   */

  [
    'cart:updated',
    'cart:change',
    'cart:refresh',
    'ajaxProduct:added',
    'product:added'
  ].forEach(function (eventName) {

    document.addEventListener(
      eventName,
      function () {

        /*
         * Allow the theme's cart AJAX request
         * to finish first.
         */

        setTimeout(
          updateGift,
          300
        );

      }
    );

  });


  /*
   * ============================================================
   * NORMAL ADD TO CART
   * ============================================================
   *
   * Catches forms such as:
   *
   * <form action="/cart/add">
   */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target;


      if (
        form &&
        form.matches &&
        form.matches(
          'form[action*="/cart/add"]'
        )
      ) {

        console.log(
          'COLOR WOW gift: normal Add to Cart detected'
        );


        /*
         * Give the theme time to finish
         * its AJAX cart request.
         */

        setTimeout(
          updateGift,
          800
        );

      }

    },
    true
  );


  /*
   * ============================================================
   * QUICK ADD
   * ============================================================
   */

  document.addEventListener(
    'click',
    function (event) {

      const quickAddButton =
        event.target.closest(
          QUICK_ADD_SELECTOR
        );


      if (!quickAddButton) {

        return;

      }


      console.log(
        'COLOR WOW gift: Quick Add detected',
        quickAddButton.dataset.variantId
      );


      /*
       * Check several times because the theme
       * performs the cart update asynchronously.
       */

      checkGiftAfterQuickAdd();

    },
    true
  );


  /*
   * ============================================================
   * QUANTITY +/- BUTTONS
   * ============================================================
   */

  document.addEventListener(
    'click',
    function (event) {

      const quantitySelector =
        event.target.closest(
          '.quantity-selector'
        );


      if (!quantitySelector) {

        return;

      }


      const button =
        event.target.closest(
          'button'
        );


      if (!button) {

        return;

      }


      console.log(
        'COLOR WOW gift: quantity button detected'
      );


      checkGiftAfterQuantityChange();

    },
    true
  );


  /*
   * ============================================================
   * MANUAL QUANTITY INPUT
   * ============================================================
   */

  document.addEventListener(
    'change',
    function (event) {

      const input =
        event.target;


      if (
        !input ||
        !input.matches ||
        !input.matches(
          '.quantity-selector input[name="quantity"]'
        )
      ) {

        return;

      }


      console.log(
        'COLOR WOW gift: quantity changed',
        input.value
      );


      checkGiftAfterQuantityChange();

    },
    true
  );


  /*
   * ============================================================
   * SIDE CART CHECKOUT
   * ============================================================
   *
   * Exact selector:
   *
   * #react-side-cart
   * .side-cart__checkout
   * a[href="/checkout"]
   */

  document.addEventListener(
    'click',
    function (event) {

      const checkoutLink =
        event.target.closest(
          SIDE_CART_CHECKOUT_SELECTOR
        );


      if (!checkoutLink) {

        return;

      }


      console.log(
        'COLOR WOW gift: side-cart checkout detected'
      );


      protectCheckout(event);

    },
    true
  );


})();